// extracted by mini-css-extract-plugin
export default {"footer":"Panel_footer__pcDWb"};